<template>
  <div class="productSorting">
    <div class="search-box">
      <div class="input-item">
        <span class="label">产品名称</span>
        <Select
          v-model="productCode"
          style="width: 400px"
          filterable
          clearable
          @on-change="selectChange"
        >
          <Option
            v-for="item in productList"
            :value="item.productCode"
            :key="item.productCode"
            >{{ item.productName }}</Option
          >
        </Select>
      </div>
    </div>
    <div class="tab-box">
      <Tabs v-model="insuranceType" :animated="false" @on-click="checkTabs">
        <TabPane :label="item.name" :name="item.id" v-for="(item, index) in typeList" :key="index"></TabPane>
      </Tabs>
      <Tabs v-model="twoInsuranceType" class="second-tabs" :animated="false" v-if="insuranceType != '0'"
        @on-click="getList">
        <TabPane :label="bean.name" :name="bean.id" v-for="(bean, i) in twoTypeList" :key="i"></TabPane>
      </Tabs>
    </div>
    <div class="btn-item">
      <Button type="primary" @click="topTopMany">置顶</Button>
      <Button type="primary" @click="toTopStep">上移</Button>
      <Button type="primary" @click="toBottomStep">下移</Button>
      <Button type="primary" @click="topBottomMany">置底</Button>
    </div>
    <div class="table-box template-table" style="margin: 20px 0;">
      <loading :isShow="listLoading" />
      <table width="100%" v-if="productList && productList.length > 0">
        <thead>
          <tr>
            <th style="width: 80px">
              <!-- <Checkbox v-model="selectAll" @on-change="changeCheckBox"></Checkbox> -->
            </th>
            <th>产品名称</th>
            <th style="width: 120px">产品编码</th>
            <th style="width: 160px">保险公司</th>
            <th style="width: 100px">业务类别</th>
            <th style="width: 160px" v-if="$units.superviseShowVal()">供应商</th>
            <th style="width: 120px" v-if="$units.pointAction('operate_3_5')">服务费率</th>
            <th style="width: 100px">是否热销</th>
            <th style="width: 160px">操作</th>
          </tr>
        </thead>
        <draggable v-model="productList" element="tbody" @update="update">
          <tr v-for="(item, index) in productList" :key="item.id" :class="{ activeTr: item.active }">
            <td style="width: 80px">
              <Checkbox v-model="item.selected"></Checkbox>
            </td>
            <td>{{ item.productName }}</td>
            <td style="width: 120px">{{ item.productCode }}</td>
            <td style="width: 160px">{{ item.companyName }}</td>
            <td style="width: 100px" class="sellTypeColumn">
              <Tag color="blue" v-if="item.sellType.includes('1')">网销</Tag>
              <Tag color="blue" v-if="item.sellType.includes('2')">电销</Tag>
              <Tag color="blue" v-if="item.sellType.includes('3')">经代</Tag>
              <div v-if="!item.sellType">/</div>
            </td>
            <td style="width: 160px" v-if="$units.superviseShowVal()">{{ item.supplierName }}</td>
            <td style="width: 120px" v-if="$units.pointAction('operate_3_5')">
              <template v-if="item.min != item.max">
                <span>{{ item.min }}%</span>-<span>{{ item.max }}%</span>
              </template>
              <span v-else>{{ item.min || 0 }}%</span>
            </td>
            <td style="width: 100px">{{ getHotStatus(item.isHot) }}</td>
            <td style="width: 160px">
              <div>
                <span v-if="index != 0" class="table-btn"><i class="iconfont iconyidong-xiangshang"
                    @click="moveSigleUp(index)"></i></span>
                <span v-if="index != productList.length - 1" class="table-btn"><i
                    class="iconfont iconyidongxiangxia" @click="moveSigleDown(index)"></i></span>
                <span v-if="index != 0" class="table-btn"><i class="iconfont iconyidong-zhiding" @click="topTopSingle(index)"></i></span>
                <span v-if="index != productList.length - 1" class="table-btn" @click="topBottomSingle(index)"><i class="iconfont iconyidong-zhidi"></i></span>
              </div>
            </td>
          </tr>
        </draggable>
      </table>
      <no-data v-if="!productList.length"></no-data>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { pageTool, common } from '@/api/mixins';
export default {
  mixins: [pageTool, common],
  components: {
    draggable,
  },
  data() {
    return {
      productCode: '',
      insuranceType: '0',
      twoInsuranceType: '0',
      listLoading: false,
      data: [],
      typeList: [
        {
          id: '0',
          name: '全部',
        },
      ],
      twoTypeList: [
        {
          id: '0',
          name: '全部',
        },
      ],
      productList: []
    }
  },
  mounted() {
    this.getTypeList()
    this.getList()
  },
  methods: {
    getHotStatus(status){
      if(status == 0){
        return '否'
      }else if(status == 1){
        return '是'
      }else{
        return ''
      }
    },
    update() {
      this.moveHttp()
    },
    // 请求移动接口
    moveHttp() {
      let list = [];
        list = JSON.parse(JSON.stringify(this.productList));
        let thisList = []
        thisList = list.map(item => {
          return item.productCode
        });
        let url,data
      if (this.insuranceType == '0') {
        url = '/buz/organizationProduct/rank'
        data = {
          productCodes:thisList
        }
      }else{
        url = '/buz/merchantProductThemeJoin/rank'
        data = {
          productCodes:thisList,
          themeId:this.twoInsuranceType == '0'?this.insuranceType:this.twoInsuranceType
        }
      }
      this.$http({
        url: url,
        type: 'POST',
        data: data
      });
    },
    //置顶
    topTopSingle(index) {
      const length = this.productList.length;
      this.productList.unshift(this.productList.splice(index, 1)[0]);
      this.moveHttp()
      // 取消选中
      this.resetCheckBox()
    },
    //置底
    topBottomSingle(index) {
      const length = this.productList.length;
      this.productList.push(this.productList.splice(index, 1)[0]);
      this.moveHttp()
      // 取消选中
      this.resetCheckBox()
    },
    // 单个上移
    moveSigleUp(index,val=true) {
      if (index != 0) {
        this.productList[index - 1] = this.productList.splice(
          index,
          1,
          this.productList[index - 1]
        )[0];
      }
      if(val){
        this.moveHttp()
      }
      // 取消选中
      this.resetCheckBox()
    },
    moveSigleDown(index,val=true) {
      //单条下移动
      if (index != this.productList.length - 1) {
        this.productList[index + 1] = this.productList.splice(
          index,
          1,
          this.productList[index + 1]
        )[0];
      }
      if(val){
        this.moveHttp()
      }
      // 取消选中
      this.resetCheckBox()
    },
    topTopMany() {
      const flag = this.productList.every((item) => !item.selected);
      if (flag) {
        this.$Message.warning("请勾选操作项");
        return;
      }
      let targetIndex = []; //获取勾选的下标
      let targetArr = [];
      this.productList.forEach((item, index) => {
        if (item.selected) {
          targetArr.push(item);
          targetIndex.push(index);
        }
      });
      const arr = _.cloneDeep(this.productList);
      const arr2 = arr.filter(
        (item, index) => targetIndex.indexOf(index) == -1
      );
      this.productList = [...targetArr, ...arr2];
      this.moveHttp()
      // 取消选中
      this.resetCheckBox()
    },
    topBottomMany() {
      const flag = this.productList.every((item) => !item.selected);
      if (flag) {
        this.$Message.warning("请勾选操作项");
        return;
      }
      let targetIndex = []; //获取勾选的下标
      let targetArr = [];
      this.productList.forEach((item, index) => {
        if (item.selected) {
          targetArr.push(item);
          targetIndex.push(index);
        }
      });
      const arr = _.cloneDeep(this.productList);
      const arr2 = arr.filter(
        (item, index) => targetIndex.indexOf(index) == -1
      );
      this.productList = [...arr2, ...targetArr];
      this.moveHttp()
      // 取消选中
      this.resetCheckBox()
    },
    toTopStep() {
      const flag = this.productList.every((item) => !item.selected);
      if (flag) {
        this.$Message.warning("请勾选操作项");
        return;
      }
      //上移批量
      let targetIndex = []; //获取勾选的下标
      this.productList.forEach((item, index) => {
        if (item.selected) {
          targetIndex.push(index);
        }
      });
      targetIndex.forEach((item) => {
        this.moveSigleUp(item,false);
      });
      this.moveHttp()
      // 取消选中
      this.resetCheckBox()
    },
    toBottomStep() {
      const flag = this.productList.every((item) => !item.selected);
      if (flag) {
        this.$Message.warning("请勾选操作项");
        return;
      }
      //下移批量
      let targetIndex = []; //获取勾选的下标
      this.productList.forEach((item, index) => {
        if (item.selected) {
          targetIndex.push(index);
        }
      });
      targetIndex.reverse().forEach((item) => {
        this.moveSigleDown(item,false);
      });
      this.moveHttp()
      // 取消选中
      this.resetCheckBox()
    },
    resetCheckBox() {
      this.productList.forEach((item, index) => {
        this.$set(item, "selected", false);
      });
    },
    getList() {
      this.listLoading = true;
      this.$http({
        type: "POST",
        url: '/buz/organizationProduct/all',
        data: {
          firstTag: this.insuranceType == '0' ? '' : this.insuranceType,
          secondTag: this.twoInsuranceType == '0' ? '' : this.twoInsuranceType
        },
      })
        .then((res) => {
          this.listLoading = false;
          this.productList = res.data;
        })
        .catch((err) => {
          this.listLoading = false;
        });
    },
    checkTabs(val) {
      this.$units.cancelhttpRequest()
      this.twoInsuranceType = '0'
      if (val != '0') {
        this.getTwoTypeList(val)
      }
      this.getList()
    },
    // 获取一级分类
    getTypeList() {
      this.$http({
        type: "GET",
        url: '/buz/merchantProductTheme/array/first',
        data: {},
      })
        .then((res) => {
          this.typeList = res.data
        }).finally(() => {
          this.typeList.unshift({
            id: '0',
            name: '全部',
          },)
        })
    },
    // 获取二级分类
    getTwoTypeList(parentId) {
      this.$http({
        type: "GET",
        url: '/buz/merchantProductTheme/array/second',
        data: {
          parentId: parentId
        },
      })
        .then((res) => {
          this.twoTypeList = res.data
        }).finally(() => {
          this.twoTypeList.unshift({
            id: '0',
            name: '全部',
          },)
        })
    },
    //过滤
    selectChange(code) {
      const index = this.productList.findIndex(
        (item) => item.productCode == code
      );
      this.productList.forEach((item, i) => {
        this.$set(item, "active", false);
        if (i === index) {
          this.$set(item, "active", true);
        }
      });
      this.$nextTick(() => {
        if (code) {
          var el = document.querySelector(".activeTr");
          window.scroll({ top: el.offsetTop, behavior: "smooth" });
        }
      });
    },
  }

}
</script>

<style lang="scss" scoped>
.productSorting {
  min-width: 1200px;

  /deep/ .second-tabs .ivu-tabs-bar .ivu-tabs-tab-active {
    background-color: #fff;
    color: #236DFF;
    border: 1px solid #236DFF;
    border-radius: 20px;
  }

  /deep/.second-tabs .ivu-tabs-bar .ivu-tabs-tab {
    background-color: #fff;
    padding: 4px 12px !important;
    margin-bottom: 8px;
    margin-right: 20px;
  }

  /deep/ .ivu-tabs-nav-wrap {
    margin-bottom: 0;
  }

  table {
    word-wrap: bread-word;
    word-break: break-all;
    table-layout: fixed;
    border-collapse: collapse;
    thead {
      background: #f8f8f9;
    }

    th {
      border: 1px solid #eee;
      padding: 10px 10px;
    }

    tr {
      &.activeTr {
        background: #409eff;
        color: #fff;

        .details {
          >div {
            color: #fff;
          }
        }
      }
    }

    td {
      text-align: center;
      border: 1px solid #eee;
      padding: 0 10px;
      height: 45px;
    }
  }
}</style>